import { render, staticRenderFns } from "./DefaultProjectImage.vue?vue&type=template&id=0bf911d8"
import script from "./DefaultProjectImage.vue?vue&type=script&lang=ts"
export * from "./DefaultProjectImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bf911d8')) {
      api.createRecord('0bf911d8', component.options)
    } else {
      api.reload('0bf911d8', component.options)
    }
    module.hot.accept("./DefaultProjectImage.vue?vue&type=template&id=0bf911d8", function () {
      api.rerender('0bf911d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/DefaultProjectImage.vue"
export default component.exports